<app-my-lessons
    authLevel="{{authLevel}}"
></app-my-lessons>
